export function useFormatter() {
	const truncate = (text: string, limit: number = 6): string => {
		if (!text) return '';

		const cleanedText = text.replace(/[\r\n]+/g, '').trim();

		if (cleanedText.length <= limit) {
			return cleanedText;
		}

		return cleanedText.substring(0, limit) + '..';
	};

	return {
		truncate,
	};
}
